/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import '@ciscospark/internal-plugin-mercury';
import '@ciscospark/internal-plugin-encryption';
import '@ciscospark/internal-plugin-conversation';
import '@ciscospark/internal-plugin-feature';

import {registerInternalPlugin} from '@ciscospark/spark-core';
import Lyra from './lyra';
import config from './config';

registerInternalPlugin('lyra', Lyra, {
  config
});

export {default} from './lyra';
export {config};
